// extracted by mini-css-extract-plugin
export default {"preloader":"style_preloader__gIvZ6"};